// extracted by mini-css-extract-plugin
export default {"cardHoldContainer":"CardHold_cardHoldContainer__mYXyK"};